/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CableTrayItemNumberTagComponent } from './cable-tray-item-number-tag.component';
import { SysqueDropdownOptionsLineModule } from '../../../../../../../../../../../shared/ui/src/lib/components/sysque-dropdown-options-line';
import { SysqueCheckBoxOptionsLineModule } from '../../../../../../../../../../../shared/ui/src/lib/components/sysque-check-box-options-line';
import { SysqueLocationOptionsLineModule } from '../../../../../../../../../../../shared/ui/src/lib/components/sysque-location-options-line';

@NgModule({
  declarations: [CableTrayItemNumberTagComponent],
  imports: [
    CommonModule,
    SysqueDropdownOptionsLineModule,
    SysqueCheckBoxOptionsLineModule,
    SysqueLocationOptionsLineModule
  ],
  exports: [CableTrayItemNumberTagComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CableTrayItemNumberTagModule {}
